// @flow
import React, { Suspense } from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import Icon from '@ff/ui/Icon';
import withAnalytics from 'shared/hoc/withAnalytics';

const QRCode = React.lazy(() => import(/* webpackChunkName: "qrcode" */ 'qrcode.react'));

export type Link = {
  icon: string,
  url: string
}

type Props = {
  classes: Object,
  iconStyle: Object,
  link: Link,
  generateQRCode: string,
  showQRCodeAbove: ?boolean,
  customClass: string
}

class SocialIcon extends React.Component {
  props: Props = this.props;

  state = {
    showQRCode: null
  };

  handleHover = (icon) => {
    if (icon.icon.includes('wechat')) {
      this.setState({ showQRCode: icon.url });
    }
  }

  handleClick = (e, icon) => {
    e.preventDefault();

    this.props.analytics.trackSocialClickEvent(icon.icon, icon.url);

    if (icon.url.includes('mailto')) {
      location.href = icon.url;
    } else if (!icon.icon.includes('wechat')) {
      window.open(
        icon.url,
        '_blank'
      );
    }
  }

  render() {
    const {
      classes: c, link, iconStyle, generateQRCode, customClass, showQRCodeAbove = true
    } = this.props;
    const { showQRCode } = this.state;
    const qrCode = showQRCode && (generateQRCode ? (
      <div className={classNames(c.qrCode, c.withBorder, showQRCodeAbove && c.qrCodeAbove)}>
        <Suspense fallback={<div />}>
          <QRCode value={generateQRCode} />
        </Suspense>
      </div>
    ) : (
      <img className={classNames(c.qrCode, showQRCodeAbove && c.qrCodeAbove)} src={showQRCode} alt="" />
    ));


    return (
      <div
        className={c.container}
        onMouseEnter={() => this.handleHover(link)}
        onMouseLeave={() => this.setState({ showQRCode: null })}
      >
        <Icon
          name={link.icon}
          style={iconStyle}
          className={customClass}
          onClick={e => this.handleClick(e, link)}
        />
        {link.icon.includes('wechat') && qrCode}
      </div>
    );
  }
}

const styles = {
  container: {
    position: 'relative'
  },
  qrCode: {
    position: 'absolute',
    left: '-64px',
    width: '128px',
    minWidth: '128px !important',
    height: '128px',
    boxSizing: 'content-box'
  },
  qrCodeAbove: {
    bottom: '32px'
  },
  withBorder: {
    border: '5px white solid'
  }
};

export default withAnalytics(injectSheet(styles)(SocialIcon));
